// @flow

import React, { PureComponent } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { i18n } from 'shared/utils';
import * as Actions from 'main-app/store/Actions';
import DeleteJobYieldMutation from 'main-app/mutations/DeleteJobYield';
import Button from 'shared/components/common/Button';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'shared/components/modal';
import type { DeleteJobYieldModal_jobYield as JobYieldFragment } from './__generated__/DeleteJobYieldModal_jobYield';

type Props = {
  onClose: () => void,
  jobId: string,
  jobYield: JobYieldFragment,
};

type State = {
  deleting: boolean,
};

class DeleteJobYieldModal extends PureComponent<Props, State> {
  state = {
    deleting: false,
  };

  handleDelete = () => {
    const { jobId, jobYield, onClose } = this.props;

    this.setState(
      {
        deleting: true,
      },
      async () => {
        try {
          await DeleteJobYieldMutation.commit({
            variables: {
              input: {
                id: jobYield.id,
              },
            },
            context: {
              jobId,
            },
          });

          onClose();
          Actions.alertNotification(
            i18n.t(`Item Successfully Removed`),
            'success',
          );
        } catch (e) {
          this.setState({ deleting: false });

          Actions.alertNotification(e.message, 'error');
        }
      },
    );
  };

  render() {
    const { deleting } = this.state;
    const { jobYield, onClose } = this.props;

    return (
      <Modal maxWidth={700}>
        <ModalHeader
          header={i18n.t('Remove Item: {{itemName}}?', {
            itemName: jobYield.item.name,
          })}
          onClose={onClose}
        />
        <ModalBody withPadding>
          {i18n.t(
            `Removing "${jobYield.item.name}" will also remove it from associated runs.`,
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            type="submit"
            theme="border-white"
            loading={deleting}
            onClick={this.handleDelete}
          >
            {i18n.t('Yes, Remove Item')}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default createFragmentContainer(DeleteJobYieldModal, {
  jobYield: graphql`
    fragment DeleteJobYieldModal_jobYield on JobYield {
      id
      item {
        id
        name
      }
    }
  `,
});
